import React, { useState,useEffect}from 'react'
import { Flex, Picker, List, InputItem, Button, Toast } from 'antd-mobile-v2';
import { getIpAddress } from '@api/info-collect';
import { checkCompanyName,getPhoneNumber,createCompany } from '@api/company.api';
import { province as provinceList } from '../../constant/province.constant';
import { getCityListByProvinceId } from '@api/agile.api';
import { useHistory } from 'react-router-dom';
import store from '@store/index';
import './register.css'
type Picker_Item={
  value: string;
  label: string;
}

const Register = () => {
  //@ts-ignore
  let data: any = JSON.parse(window.sessionStorage.getItem("registerData"));
  const [province, setProvince] = useState(data?.province||{ value: '310000', label: '上海市' });
  const [city, setCity] = useState(data?.city||{ value: '310101', label: '黄浦区' });
  const [cityList, setCityList] = useState([] as Picker_Item[]);
  const [companyType, setCompanyType] = useState(data?.companyType||{ value: '1', label: '公司类型-装修公司' })
  const [name, setName] = useState(data?.companyName||'');
  const [canRegister, setCanRegister] = useState(true);
  const [telephone, setTelephoen] = useState('');
  const [longitude, setLongitude] = useState('');
  const [latitude, setLatitude] = useState('');
  const typeLs = [
    { value: '1', label: '装修公司' },
    { value: '3', label: '材料商' },
  ];
  const history = useHistory();
  useEffect(() => {
    document.title = '注册';
    initPhoneNumber();
    initProvince();
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [])

  useEffect(() => {
    initCityList();
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [province])
  
  const initPhoneNumber = async() => {
    let res = (await getPhoneNumber(Number(store.getState().user.personId))).data;
    setTelephoen(res.telephone)
  }
  const initProvince = async () => {
    if (data?.province) return;
    let res = await getIpAddress();
    const { province, lat, lng } = res.data.data;
    setLongitude(lng);
    setLatitude(lat);
    const provinceItem = provinceList.find((item: Picker_Item) => {
      return item.label === province;
    })
    if (provinceItem) {
      setProvince(provinceItem); 
    }
  }
  const initCityList = async() => {
    let cityList = (await getCityListByProvinceId(province.value)).data.result[0];
    let arr = cityList.map((item: any) => {
      return {
        value: item.id,
        label: item.fullname
      }
    });
    setCityList(arr);
    if (data?.city) return;
    setCity(arr[0])
  }
  const registerEvent = async () => {
    if (!name) {
      Toast.info('请输入公司名称', 1);
      return;
    };
    if (!canRegister) return;
    setCanRegister(false);
    let checkBoolean = (await checkCompanyName({
      companyName: name,
      province: province.label,
      city: city.label,
    })).data.data;
    if (checkBoolean) {
      let statePayload = {
        province: province,
        city: city,
        companyType: companyType,
        companyName: name,
      }
      window.sessionStorage.setItem('registerData', JSON.stringify(statePayload));
      history.push({
        pathname: 'sameNameCompany',
        state: {
          province: province.label,
          city: city.label,
          companyType: companyType.value,
          companyName: name,
          shortName: convertShortName(name),
          latitude: latitude,
          longitude: longitude,
          personId: store.getState().user.personId,
          phone: telephone,
        }
      })
    } else {
      let params = {
        province: province.label,
        city: city.label,
        companyType: companyType.value,
        companyName: name,
        shortName: convertShortName(name),
        latitude: latitude,
        longitude: longitude,
        personId: store.getState().user.personId,
        phone: telephone,
      };
      setTimeout(() => {
        setCanRegister(true);
      }, 5000);
      //@ts-ignore
      await createCompany(params); //创建公司
      Toast.info('注册成功', 1500);
      setTimeout(() => {
        window.location.href = "https://cdn.1qizhuang.com/react_worker/#/downloadApp"
      }, 1500);
    }
  }
  const convertShortName=(name: string)=> {
    if (name && name.length) {
      if (name.length <= 5) {
        return name;
      }
      var pattern = /装潢|装璜|装饰|装修|设计|建筑|工程|室内|家庭|有限|公司|红星美凯龙/g;
      var shortName = name.replace(pattern, '');
      return shortName;
    } else {
      return '';
    }
  }
  return (
    <div style={styles.container}>    
      <Flex direction="column">
        <div style={styles.title}>注册公司账号</div>
        <div style={styles.tip}>填写准确信息，赢得客户更信任</div>
      </Flex>
      <List style={styles.list}>
        <Picker
          data={provinceList}
          cols={1}
          onOk={(value: string) => {  
            let item = provinceList.find((item) => {
              return item.value === value[0]
            });
            if (item) {
              setProvince(item); 
            }
          }}
          value={[province.value]}>
          <List.Item arrow="horizontal" style={styles.pickerItem}>
            <div style={styles.listItemName}>省</div>
          </List.Item>
        </Picker>
        <Picker
          data={cityList}
          cols={1}
          value={[city.value]}
          onOk={(value: string) => {
            let item = cityList.find((item) => {
              return item.value === value[0]
            });
            if (item) {
              setCity(item);
            }
          }}>
          <List.Item arrow="horizontal" style={styles.pickerItem}>
            <div style={styles.listItemName}>市</div>
          </List.Item>
        </Picker>
        <Picker
          data={typeLs}
          cols={1}
          onOk={(value: string) => { 
            let item = typeLs.find((item) => {
              return item.value === value[0]
            });
            if (item) {
              setCompanyType(item);
            }
           }}
          value={[companyType.value]}>
          <List.Item arrow="horizontal" style={styles.pickerItem}>
            <div style={styles.listItemName}>公司类型</div>
          </List.Item>
        </Picker>
        <InputItem
          clear
          maxLength={30}
          value={name}
          style={styles.input}
          placeholder="请输入公司名字"
          onChange={(value) => {setName(value)}}>
          </InputItem>
      </List>
      <Button style={styles.button} onClick={registerEvent}>
        <span style={styles.register}>注册</span>
      </Button>
      <div style={styles.bottomTip}>同一公司只需注册一个账号。如已有同事注册，可以让他将您添加到已注册的公司账号。</div>
    </div>
  )
}

const styles = {
  container: {
    height:'100vh',
    backgroundColor:'white',
  },
  title: {
    fontSize: 15,
    color: '#444444',
    fontWeight: 400,
    marginTop: 30,
    marginBottom:10,
  },
  tip: {
    fontSize: 12,
    fontWeight: 400,
    color: '#9B9B9B',
    marginBottom:30,
  },
  list: {
    paddingLeft: 30,
    paddingRight: 30,
  },
  pickerItem: {
    backgroundColor: '#F4F4F4',
    height: 45,
    borderRadius: 5,
    marginBottom: 10,
  },
  listItemName: {
    fontSize: 15,
    fontWeight: 400,
    color: '#444444',
  },
  input: {
    backgroundColor: '#F4F4F4',
  },
  button: {
    marginTop: 30,
    marginLeft: 30,
    marginRight: 30,
    marginBottom: 10,
    backgroundColor: '#36BE66',
  },
  register: {
    fontSize: 15,
    fontWeight: 400,
    color: '#FFFFFF',
  },
  bottomTip: {
    fontSize: 12,
    lineHeight:1.4,
    fontWeight: 400,
    color: '#9B9B9B',
    marginLeft: 30,
    marginRight:30,
  }
}
export default Register;